export class PessoaModel {
  constructor(init?: Partial<PessoaModel>) {
    Object.assign(this, init);
  }

  codigo: number = 0;
  nome: string = '';
  celulares: Array<string> = [];
  cidade: string = '';
  bairro: string = '';
  pontoReferencia: string = '';
  pontoRef: string = '';
  endereco: string = '';
  numero: string = '';
  enderecos: EnderecoPessoa[] = []
}

export class EnderecoPessoa {
  codigo: number = 0;
  codPessoa: number = 0;
  nome: string = '';
  numero: string = '';
  pontoRef: string = '';
  pontoReferencia: string = '';
  bairro: string = '';
  cep: string = '';

  getEnderecoCompleto() {
    let text = "";

    if (this.nome.length == 0)
      return "";

    text = this.nome;

    if (this.numero.length > 0)
      text = text + ', ' + this.numero;

    if (this.pontoRef.length > 0)
      text = text + ', ' + this.pontoRef;

    if (this.bairro.length > 0)
      text = text + ', ' + this.bairro;

    return text;
  }
}

export class ClienteRequest {
    public nome: string = "";
    public endereco: string = "";
    public telefone: string = "";
}